import React from 'react';

import loading from 'assets/images/loading-campos.svg';
import { LoadingWrapper } from './styles';

const LoadingIndicator = () => {
  return (
    <LoadingWrapper>
      <img src={loading} alt="" />
    </LoadingWrapper>
  );
};

export default React.memo(LoadingIndicator);
